/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Comunicados de prensa - CamAPS FX',
    titleMeta: 'Comunicados de prensa - CamAPS FX',
    descriptionMeta: 'Últimos comunicados de prensa y noticias de CamAPS FX.',
    keywords: 'comunicados de prensa camaps, noticias camaps, noticias tecnología diabetes',
    localeMeta: 'es_es',

    bannerTitle: 'Comunicados de prensa',
    bannerSubtitle: 'Mantente al día con nuestros últimos anuncios',

    contactText: 'Para consultas de prensa, póngase en contacto a través de <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Todos los comunicados de prensa se publican en inglés.',

    download: 'Descargar',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
};

